import { Component, Input, OnInit } from '@angular/core';
import { HxAuthService, HxOrganizationService, OrganizationModel } from 'hx-services';
import { NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam, NzUploadComponent, NzUploadFile } from 'ng-zorro-antd/upload';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { buildGooglePublicUrl } from '@adm-web-app/utils';
import { NgIf } from '@angular/common';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { MarkdownComponent } from 'ngx-markdown';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hc-payment-agreement-edit',
    templateUrl: './payment-agreement-edit.component.html',
    styleUrls: ['./payment-agreement-edit.component.less'],
  imports: [NgIf, NzSpinComponent, MarkdownComponent, NzModalFooterDirective, NzUploadComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, TranslocoPipe]
})
export class PaymentAgreementEditComponent implements OnInit {
  @Input() organization!: OrganizationModel;
  isLoading = {
    agreement: false,
    upload: false,
  };
  fileUploadUrl!: string;
  agreementFileUrl!: string;

  fileUploadHeadersFn = () => {
    const token = this.auth.keycloakToken();
    return {
      Authorization: `Bearer ${token}`,
      'ngsw-bypass': 'true'
    };
  };

  constructor(
    public modalRef: NzModalRef,
    private orgService: HxOrganizationService,
    private auth: HxAuthService,
    private notificationService: NzNotificationService,
  ) {
  }

  ngOnInit(): void {
    this.isLoading.agreement = true;
    this.fileUploadUrl = this.orgService.getPaymentAgreementUploadUrl(this.organization.id);
    this.agreementFileUrl = buildGooglePublicUrl(`/payment-agreement/${this.organization.id}-ru.md`);
  }

  onAgreementLoaded() {
    this.isLoading.agreement = false;
  }

  handleChange(event: NzUploadChangeParam) {
    this.isLoading.agreement = true;
    this.isLoading.upload = event.type === 'start' || event.type === 'progress';
    if (event.type === 'success') {
      this.notificationService.success('Загрузка', 'Пользовательское соглашение сохранено');
    }
  }
}
